"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

require("core-js/modules/es.error.cause.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.test.js");

var _jsMd = _interopRequireDefault(require("js-md5"));

var _message = require("@/components/dialog/message");

var _forgetPwd = require("@/model/user/forgetPwd");

var _i18n = require("@/assets/js/i18n");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  directives: {
    focus: {
      update: function update(el, _ref) {
        var value = _ref.value,
            oldValue = _ref.oldValue;

        if (value != oldValue) {
          el.querySelector("input").focus();
        }
      }
    }
  },
  props: ["onlyName", "token"],
  data: function data() {
    return {
      pwdData: {},
      pwdLevel: 0,
      showLevel: false,
      pwdFocus: false,
      confirmFocus: false,
      spotLevel: {},
      formRules: {
        confirmPwd: [{
          validator: this.confirmBlur,
          trigger: "change"
        }]
      },
      confirmOutline: false,
      resetLoading: false
    };
  },
  created: function created() {
    this.initialData();
  },
  methods: {
    translateTitle: _i18n.translateTitle,
    // 密码框失焦
    pwdBlur: function pwdBlur() {
      this.showLevel = false;
    },
    // 确认密码
    confirmBlur: function confirmBlur(rule, value, callback) {
      var pwd = this.pwdData.pwd;

      if (value === "" | !value) {
        callback(new Error(this.translateTitle("请输入确认密码")));
      } else if (value !== pwd) {
        this.confirmOutline = true;
        callback(new Error(this.translateTitle("两次输入密码不一致!")));
      } else {
        callback();
      }
    },
    // 重置密码点击
    resetPwd: function resetPwd() {
      var _this$pwdData = this.pwdData,
          pwd = _this$pwdData.pwd,
          confirmPwd = _this$pwdData.confirmPwd,
          _this$spotLevel = this.spotLevel,
          digit = _this$spotLevel.digit,
          enNum = _this$spotLevel.enNum;

      if (digit && enNum) {
        if (pwd !== confirmPwd) {
          this.confirmFocus = !this.confirmFocus;
        } else {
          this.confirmOutline = false;
          this.submitNewPwd();
        }
      } else {
        this.pwdFocus = !this.pwdFocus;
      }
    },
    // 密码提交
    submitNewPwd: function submitNewPwd() {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var pwd, _yield$forgetCheckUpd, msg, status;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pwd = _this.pwdData.pwd; // let only_name = this.onlyName;

                pwd = (0, _jsMd.default)(pwd);
                _this.resetLoading = true; // let { msg, status } = await forgetCheckUpdate({ pwd, only_name });

                _context.next = 5;
                return (0, _forgetPwd.forgetCheckUpdate)({
                  pwd: pwd,
                  token: _this.token
                });

              case 5:
                _yield$forgetCheckUpd = _context.sent;
                msg = _yield$forgetCheckUpd.msg;
                status = _yield$forgetCheckUpd.status;

                if (status == 200) {
                  // 去登录页
                  _this.resetLoading = false;
                  (0, _message.showMessage)({
                    message: _this.translateTitle("\u8BBE\u7F6E\u65B0\u5BC6\u7801\u6210\u529F"),
                    type: "success"
                  });

                  _this.$router.push({
                    name: "Login"
                  });
                } else {
                  _this.resetLoading = false;
                  (0, _message.showMessage)({
                    message: msg ? msg : status
                  });
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 检测密码是否合规
    checkChange: function checkChange() {
      var pwd = this.pwdData.pwd;
      var length = pwd.length;

      if (!pwd || /^\s$/.test(pwd)) {
        this.initialData();
      } else if (length < 6) {
        // 一级灰点
        this.spotLevel.digit = false;
        this.check_level(pwd);
        this.pwdLevel = 0;
      } else if (6 <= length && length < 10) {
        // 一级绿点
        this.spotLevel.digit = true;
        this.check_level(pwd);
      } else {
        this.spotLevel.digit = true;
        this.check_level(pwd);
      }
    },
    // 检测英文数字：必须包含英文和数字，允许包含符号（不允许包含空格）
    check_En_Num: function check_En_Num(val) {
      if (/^(?=.*[a-zA-Z]+)(?=.*[0-9]+)(?=.*[\S]*)[a-zA-Z0-9?=.*[·~！@#￥%……&*（）——\-+=【】{}、|；‘’：“”《》？，。、`~!#$%^&*()_[\]{}\\|;'':"",./<>?]+$/.test(val)) {
        return true;
      } else {
        return false;
      }
    },
    // 检测符号：必须包含符号，允许包含 英文，数字，空格
    check_En_Num_Symbol: function check_En_Num_Symbol(val) {
      if (/^(?=.*[·~！@#￥%……&*（）——\-+=【】{}、|；‘’：“”《》？，。、`~!#$%^&*()_[\]{}\\|;'':"",./<>?]+)[\sa-zA-Z0-9·~！@#￥%……&*（）——\-+=【】{}、|；‘’：“”《》？，。、`~!#$%^&*()_[\]{}\\|;'':"",./<>?]+$/.test(val)) {
        return true;
      } else {
        return false;
      }
    },
    check_level: function check_level(pwd) {
      var length = pwd.length;

      if (this.check_En_Num(pwd)) {
        // 二级绿点
        this.spotLevel.enNum = true; // 密码等级

        if (6 <= length && length < 8) {
          this.pwdLevel = 1;
        } else if (length >= 8) {
          this.pwdLevel = 2;
        }
      } else {
        // 二级灰点
        this.spotLevel.enNum = false;
      }

      if (this.check_En_Num_Symbol(pwd)) {
        // 三级绿点
        this.spotLevel.symbol = true; // 密码等级

        if (6 <= length && length < 8) {
          this.pwdLevel = 1;
        } else if (length >= 8) {
          if (this.check_En_Num(pwd)) {
            this.pwdLevel = 3;
          }
        }
      } else {
        // 三级灰点
        this.spotLevel.symbol = false;
      }

      if (/^[a-zA-Z]*$/.test(pwd)) this.pwdLevel = 0;
      if (/^[0-9]*$/.test(pwd)) this.pwdLevel = 0;
      if (/^[?=.*[·~！@#￥%……&*（）——\-+=【】{}、|；‘’：“”《》？，。、`~!#$%^&*()_[\]{}\\|;'':"",./<>?]*$/.test(pwd)) this.pwdLevel = 0;
      if (/^[0-9?=.*[·~！@#￥%……&*（）——\-+=【】{}、|；‘’：“”《》？，。、`~!#$%^&*()_[\]{}\\|;'':"",./<>?]*$/.test(pwd)) this.pwdLevel = 0;
      if (/^[a-zA-Z?=.*[·~！@#￥%……&*（）——\-+=【】{}、|；‘’：“”《》？，。、`~!#$%^&*()_[\]{}\\|;'':"",./<>?]*$/.test(pwd)) this.pwdLevel = 0;
      if (!this.check_En_Num(pwd)) this.pwdLevel = 0;
    },
    initialData: function initialData() {
      this.pwdLevel = 0;
      this.spotLevel = {
        digit: false,
        enNum: false,
        symbol: false
      };
    }
  },
  computed: {
    levelText: function levelText() {
      var tempLevel = "";

      switch (this.pwdLevel) {
        case 0:
          tempLevel = "";
          break;

        case 1:
          tempLevel = "弱";
          break;

        case 2:
          tempLevel = "中";
          break;

        case 3:
          tempLevel = "强";
      }

      return tempLevel;
    }
  }
};
exports.default = _default;